import axios from '@/request';
import qs from 'qs';

export default {
    async list(params: any) {
        return axios.get('blocklist/list', { params });
    },
    async add(params: any) {
        return axios.post('blocklist/add', qs.stringify(params));
    },
    async edit(params: any) {
        return axios.post('blocklist/edit', qs.stringify(params));
    },
    async detail(params: any) {
        return axios.get('blocklist/detail', { params });
    },
    async delete(params: any) {
        return axios.post('blocklist/delete', qs.stringify(params));
    }
}
